import React from 'react';
import {Container,Row,Col} from "react-bootstrap";
import {StaticImage} from "gatsby-plugin-image";
import {Link} from "gatsby";
import BgImg from '../../images/services-usa/game_update/game_category.webp';

function GameCategory(props) {
    return (
        <section className="gamecategory p50"   style={{backgroundImage: `url(${BgImg})`}}>
            <Container className="h-100">
                <Row  className="h-100">
                    <Col xxl={5} xl={5} lg={6} xl={5} className="my-auto">
                     <h2>TekRevol's Array of Game App Development Categories</h2>
                        <p>Our expertise spans across a spectrum of genres, ensuring that every game we craft is a unique masterpiece tailored to captivate and engage distinct audiences.</p>
                        <p>Here are the game development categories that we have expertise in:</p>
                        <Link to="" className="border_btn">Let’s Build Your Game App</Link>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} xl={6} className="offset-xl-1">
                        <div className="main_category_box">
                            <div className="gamecategory_list">
                                <div className="item_cat">
                                <StaticImage
                                src="../../images/services-usa/game_update/adventure-games.webp"
                                alt="adventure-games"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["webp"]}
                                width={236}
                                height={236}
                                />
                                </div>
                                <div className="item_cat">
                                <StaticImage
                                src="../../images/services-usa/game_update/action-games.webp"
                                alt="action-games"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["webp"]}
                                width={236}
                                height={236}
                                />
                                </div>
                                <div className="item_cat">
                                <StaticImage
                                src="../../images/services-usa/game_update/role-playing-games.webp"
                                alt="tekrevol_web_game"
                                layout="constrained"
                                placeholder="blurred"
                                formats={["webp"]}
                                width={236}
                                height={236}
                                />
                                </div>
                            </div>
                            <div className="gamecategory_list">
                                <div className="item_cat">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/casual-games.webp"
                                        alt="casual-games"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={236}
                                        height={236}
                                    />
                                </div>
                                <div className="item_cat">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/first-person-games.webp"
                                        alt="first-person-games"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={236}
                                        height={236}
                                    />
                                </div>
                                <div className="item_cat">
                                    <StaticImage
                                        src="../../images/services-usa/game_update/puzzle-games.webp"
                                        alt="puzzle-games"
                                        layout="constrained"
                                        placeholder="blurred"
                                        formats={["webp"]}
                                        width={236}
                                        height={236}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default GameCategory;